module.exports = __webpack_public_path__ + "static/media/BLU-NEW.260f4719.apng";